import { useEffect } from 'react';
import { OptionsHeading } from '../EditorConditionFieldOptions';
import UITruncateString from 'UIComponents/text/UITruncateString';
import EditorFieldOption from '../EditorFieldOption';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import { Section } from 'foundations-components/transitional/components/Section';
import { useSuggestedProperties } from './useSuggestedProperties';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PropertySearchSuggestionsComponent = props => {
  const {
    filterFamily,
    searchString,
    hiddenProperties,
    onSelectField,
    suggestedPropertiesResultsRef
  } = props;
  const {
    options,
    loading,
    error
  } = useSuggestedProperties({
    searchString,
    filterFamily,
    hiddenProperties
  });
  useEffect(() => {
    if (suggestedPropertiesResultsRef) {
      suggestedPropertiesResultsRef.current = options;
    }
  }, [options, suggestedPropertiesResultsRef]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OptionsHeading, {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.fieldSelectFlow.recommendedProperties"
        })
      })
    }), loading && /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.loadingRecommendedProperties"
      }),
      showLabel: true,
      size: "small"
    }), !loading && (error || !options || !options.length) && /*#__PURE__*/_jsx(Section, {
      paddingInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.noRecommendedProperties"
      })
    }), options && options.map(property => {
      return /*#__PURE__*/_jsx(EditorFieldOption, {
        field: property,
        filterFamily: filterFamily,
        onClick: () => onSelectField(property, true)
      }, property.label);
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    })]
  });
};